import UserLocationBar from './UserLocationBar.vue';
import UserLocationModal from './UserLocationModal.vue';

export default {
    UserLocationBar,
    UserLocationModal,
};